const signHotelLines = [
    // Line 1
    "This bed is a thought—\nnot where sleep begins or ends,\nbut where dreams detour",
    // Line 2
    "Midnight whispers loud\nthrough vents and motel curtains—\nwho else couldn't sleep?",
    // Line 3
    "Soft sheets, heavy eyes.\nBehind every 'Do Not Disturb'\nis a story paused.",
    // Line 4
     "Luggage by the door,\na soft click of lights shut off—\nrest, borrowed again.",
  ];

export default signHotelLines;
